import { Grid, Box, Typography, Button } from "@mui/material";

export const CardWarningModal = ({ setShowWarningModal }) => {
  return (
    <Box pb={1}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"center"}>
            <Typography variant="title" color={"primary"}>
              {"!Atención!"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontSize: 18 }} textAlign={"center"} s>
            Solo podrás inscribir una tarjeta débito de
            <a> Bancolombia </a> o<a> Davivienda</a> con código de verificación
            <a> cvv</a>.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={2}>
            <Button
              variant={"contained"}
              color={"primary"}
              fullWidth
              onClick={() => setShowWarningModal(false)}
            >
              {"Aceptar"}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
